

import React, { useState } from "react";
import "../assets/css/card.css";
import { useCart } from "../context/CartContext";
import SecondModal from "../assets/images/secondmodal.jpg";
import { NotificationManager } from "react-notifications";
import DetailModal from '../assets/images/detailmodal.jpg'


const Card = ({ title, items = {} }) => {
  const [chosenPlan, setChosenPlan] = useState(null);
  const [quantity, setQuantity] = useState(1); // for Add-Ons
  const { addToCart } = useCart();
  const [loading, setLoading] = useState(false);

  const description = items?.description || "";
  const packageItems = Array.isArray(items?.plans) ? items.plans : [];

  // Find cheapest plan (for display on card)
  // const minPlan =
  //   packageItems.length > 0
  //     ? packageItems.reduce((min, plan) =>
  //       Number(plan.price) < Number(min.price) ? plan : min
  //     )
  //     : null;

  const startingPrice = items?.starting_price || null;

  // Unique modal id
  const modalId = `modal-${title.replace(/\s+/g, "-")}`;

  // ✅ booking flag
  const allowBooking = items?.booking === true;

  // --- Handle Add to Cart + Booking ---
  const handleChoose = async () => {
    if (!chosenPlan) return;
    setLoading(true);

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        NotificationManager.warning("Please login first!");
        setLoading(false);
        return;
      }

      let price = chosenPlan.price;

      // if(typeof price === "string" && isNaN(Number(price))){
      //   NotificationManager.warning("This plan requires a custom quote. Please contact support.")
      //   setLoading(false);
      //   return
      // }
      if (!price || (typeof price === "string" && isNaN(Number(price)))) {
        NotificationManager.warning("This plan requires a custom quote. Please contact support");
        setLoading(false);
        return;
      }

      // let itemToAdd;
      price = Number(price) || 0;
      let qty = quantity || 1;

      // if (title === "Add-Ons") {
      // const qty = quantity || 1;
      const itemToAdd = {
        service: title,
        ...chosenPlan,
        price,
        quantity: qty,
        totalPrice: price * qty,
      };


      const bookingPayload = {
        note: JSON.stringify(itemToAdd),
        price: itemToAdd.totalPrice,
      };

      const res = await fetch(
        `${process.env.REACT_APP_HOST_API_URL}/api/booking/add/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(bookingPayload),
        }
      );

      const data = await res.json();

      if (data.status !== 200) {
        NotificationManager.error(data.message || "Booking failed");
        setLoading(false);
        return;
      }

      addToCart(itemToAdd);

      // const existingCart = JSON.parse(localStorage.getItem("cart")) || [];
      // existingCart.push(itemToAdd);
      // localStorage.setItem("cart", JSON.stringify(existingCart));

      NotificationManager.success("Service added to cart");
      setLoading(false);
    } catch (err) {
      console.error("Booking error:", err);
      NotificationManager.error("Something went wrong!");
      setLoading(false);
    }
  };

  return (
    <>
      {/* ---- Card ---- */}
      <div
        className="plan shadow-sm border rounded d-flex flex-column mx-auto"
        style={{ width: "100%", maxWidth: "300px", minHeight: "420px" }}
      >
        <div className="inner py-4 px-3 d-flex flex-column flex-grow-1">
          <p className="title text-center h5">{title}</p>
          <span className="text-muted text-center">Starting from</span>
          <span className="h1 text-center fw-bold">
            {/* {minPlan ? `$${minPlan.price}` : "--"} */}
            {startingPrice ? `$${startingPrice}` : "--"}
          </span>

          {description && (
            <p className="text-center text-muted mt-3">
              {/* {description}{" "}
              {minPlan?.sessions && (
                <>
                  <strong>{minPlan.sessions}</strong> ·{" "}
                </>
              )}
              <strong>${minPlan?.price}</strong> */}
              {description} <strong>${startingPrice}</strong>
            </p>
          )}

          <div className="action mt-auto text-center">
            <button
              type="button"
              className="btn btn-outline-primary w-100 py-2 rounded-1"
              data-bs-toggle="modal"
              data-bs-target={`#${modalId}`}
              onClick={() => {
                setChosenPlan(null);
                setQuantity(1);
              }}
            >
              {allowBooking ? "Choose Package" : "View Details"}
            </button>
          </div>
        </div>
      </div>

      {/* ---- Booking Modal ---- */}
      {allowBooking && (
        <div
          className="modal fade"
          id={modalId}
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby={`${modalId}Label`}
          aria-hidden="true"
          style={{ height: "90vh" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              {/* <div className="modal-header sticky-top bg-white">
                <h1 className="modal-title fs-5" id={`${modalId}Label`}>
                  Book your {title}
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div> */}

              <div className="p-2 text-center mt-5">
                <h3 style={{ color: "#0564bf" }}>{title}</h3>
              </div>

              <div>
                <h1 className="text-center px-4" style={{ color: "#0564bf" }}>
                  {/* { chosenPlan
                      ? `$${Number(chosenPlan.price) * (quantity || 1)}`
                      : ""} */}

                  {chosenPlan &&
                    typeof chosenPlan.price === "number" &&
                    !isNaN(chosenPlan.price) &&
                    `$${chosenPlan.price * (quantity || 1)}`}
                </h1>
              </div>

              <div
                className="modal-body position-relative"
                style={{
                  backgroundImage: `url(${SecondModal})`,
                  backgroundPosition: "bottom",
                  minWidth: "100%",
                  height: "70vh",
                  backgroundSize: "cover",
                  position: "relative",
                  zIndex: 1056,
                }}
              >
                {/* Plan Selector */}
                <label className="fw-bold mb-2">
                  {title === "Add-Ons" ? "Select an Add-On:" : "Select a plan:"}
                </label>
                <select
                  className="form-select"
                  value={chosenPlan ? packageItems.indexOf(chosenPlan) : ""}
                  onChange={(e) => {
                    const idx = parseInt(e.target.value);
                    setChosenPlan(packageItems[idx]);
                    setQuantity(1);
                  }}
                >
                  <option value="">
                    -- {title === "Add-Ons" ? "Choose an add-on" : "Choose a plan"} --
                  </option>
                  {packageItems.map((plan, idx) => (
                    <option key={idx} value={idx}>
                      {[
                        plan.type,
                        plan.size,
                        plan.duration,
                        plan.pax,
                        plan.frequency,
                        plan.sessions ? ` ${plan.sessions}` : "",
                        plan.price ? `$${plan.price}` : "",
                      ]
                        .filter(Boolean)
                        .join(" - ")}
                    </option>
                  ))}
                </select>

                {/* Selected Plan Preview */}
                {chosenPlan && (
                  <div
                    className="alert alert-info mt-3"
                    style={{
                      opacity: 0.9,
                      backgroundColor: "white",
                      color: "black",
                    }}
                  >
                    <strong>Selected Plan:</strong>
                    <ul className="mb-0">
                      {Object.entries(chosenPlan).map(([key, value]) => (
                        <li key={key}>
                          {key.charAt(0).toUpperCase() + key.slice(1)}:{" "}
                          {typeof value === "object"
                            ? JSON.stringify(value)
                            : value}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {items.terms_and_conditions && (
                  <div
                    className="alert alert-info mt-5"
                    style={{
                      opacity: 0.95,
                      backgroundColor: "white",
                      color: "black",
                    }}
                  >
                    <h5 className="fw-bold">Terms & Conditions</h5>
                    <p className="text-muted">{items.terms_and_conditions}</p>
                  </div>
                )}

              </div>

              <div className="modal-footer sticky-bottom">
                <div className="d-flex w-100 justify-content-between align-items-center">
                  {chosenPlan && (
                    <div className="d-flex align-items-center">
                      <label className="small me-2">Qty:</label>
                      <div className="input-group" style={{ width: "110px" }}>
                        <button
                          type="button"
                          className="btn btn-outline-danger border-0 "
                          onClick={() =>
                            setQuantity((q) => Math.max(1, q - 1))
                          }
                        >
                          –
                        </button>
                        <input
                          type="text"
                          className="form-control text-center border-0 "
                          value={quantity}
                          readOnly
                        />
                        <button
                          type="button"
                          className="btn btn-outline-success border-0"
                          onClick={() => setQuantity((q) => q + 1)}
                        >
                          +
                        </button>
                        {/* <input
                        type="number"
                        className="form-control me-3"
                        style={{ width: "80px" }}
                        min="1"
                        value={quantity}
                        onChange={(e) =>
                          setQuantity(Math.max(1, parseInt(e.target.value) || 1))
                        }
                      /> */}
                      </div>

                    </div>
                  )}
                  <div className="ms-auto">
                    <button
                      type="button"
                      className="btn btn-secondary me-2"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      disabled={!chosenPlan || loading}
                      onClick={handleChoose}
                      data-bs-dismiss="modal"
                    >
                      {loading ? "Booking..." : "Add to Cart"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ---- View-Only Modal ---- */}
      {!allowBooking && (
        <div
          className="modal fade  rounded-0"
          id={modalId}
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby={`${modalId}Label`}
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              {/* <div className="modal-header sticky-top bg-white">
                <h1 className="modal-title fs-5" id={`${modalId}Label`}>
                  {title} - Package Details
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div> */}

              <div
                className="modal-body position-relative  rounded-0"
                style={{
                  backgroundImage: `url(${DetailModal})`,
                  backgroundPosition: "top",
                  minWidth: "100%",
                  height: "70vh",

                  backgroundSize: "cover",
                  position: "relative",
                  zIndex: 1056,
                }}
              >
                <h2 className="my-3">{title}</h2>
                <div className="container">
                  <div className="row">
                    {packageItems.length > 0 ? (
                      packageItems.map((plan, idx) => (
                        <div key={idx} className="col-12 col-lg-6 mb-3   rounded-0">

                          <div
                            className="alert  position-relative  rounded-0 shadow"
                            style={{
                              // borderRadius: "10px",
                              overflow: "hidden",
                              color: "black",
                              // border: "1px solid rgba(30, 24, 24, 0.3)",
                              backgroundColor: "rgba(255,255,255,0.9)", // semi-transparent background
                              // backdropFilter: "blur(10px)", // only the background is blurred
                            }}
                          >
                            <ul className="mb-0  position-relative" style={{ zIndex: 1 }}>
                              {plan.type && <li>Type: {plan.type}</li>}
                              {plan.size && <li>Size: {plan.size}</li>}
                              {plan.duration && <li>Duration: {plan.duration}</li>}
                              {plan.sessions && <li>Sessions: {plan.sessions}</li>}
                              {plan.roomSize && <li>Room Size: {plan.roomSize}</li>}
                              {plan.cleaning && <li>Cleaning: {plan.cleaning}</li>}
                              {plan.price && <li>Price: ${plan.price}</li>}
                            </ul>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p className="text-center text-muted">
                        No package details available.
                      </p>
                    )}
                  </div>
                  {items.terms_and_conditions && (
                    <div
                      className="alert alert-info mt-4 border rounded-0 "
                      style={{
                        // borderRadius: "10px",
                        overflow: "hidden",
                        backgroundColor: "rgba(255,255,255,0.8)",
                        // border: "1px solid rgba(30, 25, 25, 0.3)",
                        backdropFilter: "blur(10px)",
                        color: "black",
                      }}
                    >
                      <h5 className="fw-bold text-danger">Notes</h5>
                      <p className="text-muted " style={{ zIndex: 1 }}>{items.terms_and_conditions}</p>
                    </div>
                  )}
                </div>
              </div>

              <div className="modal-footer sticky-bottom">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Card;
